export class UserInfo {
    Name: string;
    IsAccessAllowed: boolean;
}

export const PublicationTypes: { [id: string]: string } = {
    'UtilityModel': 'Brugsmodel',
    'Patent': 'Patent',
    'Design': 'Design',
};

export class MarkedNumber {
    number: number;
    isAdditional: boolean;
}

export class Batch {

    Publications: Publication[];
    PublicationType: string;
    Year: number;
    Vintage: number;
    Number: number;
    FirstDate: string;
    LastDate: string;

    closed: boolean;
    tidendeTypeNavn: string;
    singleDate: string;
}

export class Publication {

    Id: number;
    PublicationType: string;
    PublicationTime: string;
    Batch: Batch;
    Headers: Header[];
    Fields: Field[];

    sortText: string | null;
    anchorId: string | undefined;
    isUnapproved: boolean;
    nextUnapprovedAnchorId: string | undefined;
    prevUnapprovedAnchorId: string | undefined;
}

export class Header {

    PublicationType: string;
    UniqueId: number;
    Order: number;
    Title: string;
    SubTitle: string;
    Text: string;
    OrderByFieldId: string;
    MultiValueSeparator: string;
    CustomFormat: string;
    Publications: Publication[];

    belongsToPrevious: boolean;
    hoverText: string;
    publicationCount: number;
    unapprovedPublicationCount: number;
    firstUnapprovedAnchorId: string | undefined;
}

export class Field {

    Id: number;
    Order: number;
    Inid: number;
    ContentId: number;
    Label: string;
    Text: string;
    Headers: Header[];
    Images: Image[];

    sortText: string | null;
}

export class Image {
    Id: number;
    Reference: string;
    ImageFormat: string;

    imageSource: string;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./Frontend/src/Tidings/model.ts